import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './components/Home';
import ModernHome from './components/ModernHome';
import About from './components/About';
import Services from './components/Services';
import Products from './components/Products';
import Careers from './components/Careers';
import Referral from './components/Referral';
import Contact from './components/Contact';
import Blog from './components/Blog';
import BlogPost from './components/BlogPost';
import BlogPostView from './views/BlogPostViewClean';
import Partners from './components/Partners';
import Industries from './components/Industries';
import IndustryDetail from './components/IndustryDetail';
import PortfolioDetail from './components/PortfolioDetail';
import Portfolio from './components/Portfolio';
import Pricing from './components/Pricing';
import Team from './components/Team';
import TeamProfile from './components/TeamProfile';
import ServiceDetail from './components/ServiceDetail';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import Navbar from './components/Navbar';
import Header from './components/Header';
import Footer from './components/Footer';


function App() {
	return (
		<Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
			<Header />
			<Navbar />
			<Routes>
				<Route path="/" element={<ModernHome />} />
				<Route path="/legacy" element={<Home />} />
				<Route path="/about" element={<About />} />
				<Route path="/services" element={<Services />} />
				<Route path="/services/:slug" element={<ServiceDetail />} />
				<Route path="/portfolio" element={<Portfolio />} />
				<Route path="/portfolio/:slug" element={<PortfolioDetail />} />
				<Route path="/pricing" element={<Pricing />} />
				<Route path="/partners" element={<Partners />} />
				<Route path="/industries" element={<Industries />} />
				<Route path="/industries/:id" element={<IndustryDetail />} />
				<Route path="/team" element={<Team />} />
				<Route path="/team/:slug" element={<TeamProfile />} />
				<Route path="/products" element={<Products />} />
				<Route path="/careers" element={<Careers />} />
				<Route path="/contact" element={<Contact />} />
				<Route path="/refer" element={<Referral />} />
				<Route path="/blog" element={<Blog />} />
				<Route path="/blog/:slug" element={<BlogPostView />} />
				<Route path="/privacy" element={<Privacy />} />
				<Route path="/terms" element={<Terms />} />
			</Routes>
			<Footer />
		</Router>
	);
}

export default App;